import { CorePermissions, RiPermissions, UserPermissions } from '@/constants/permissions.constant';
import { AllValues, ValuesOf } from './types.util';

export type RiPermissionValue = AllValues<typeof RiPermissions>;
export type CorePermissionValue = AllValues<typeof CorePermissions>;

export type PermissionName = AllValues<typeof UserPermissions>;
export type ZgriPermissionName = ValuesOf<typeof UserPermissions.Zgri>;

export type Permission = {
  id: string;
  permission_name: string;
  description: string;
  human_readable_name: string;
  active: boolean;
  viewable_in_landlord_portal: boolean;
  viewable_in_prosper: boolean;
  enabled: boolean;
  state: 'assigned' | 'unassigned' | 'not-set';
};

export enum PermissionKeyEnum {
  Ri = 'ri-permissions',
  Core = 'core-permissions',
}
